module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), (_vm.clientID > 0) ? _c('b-button', {
    staticClass: "mb-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.viewClientMOM(_vm.clientID)
      }
    }
  }, [_vm._v("View MOM")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "ViewMinutesOfMeeting-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": _vm.Page_title
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "pull-right",
    attrs: {
      "cols": "4"
    }
  }, [(_vm.ClientMOMList.length > 0) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getClientMOMList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.ExcelBtnName) + "\n          "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _vm._l((_vm.ClientMOMList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "accordion",
      attrs: {
        "role": "tablist"
      }
    }, [_c('b-card', {
      staticClass: "mb-1",
      attrs: {
        "no-body": ""
      }
    }, [_c('b-card-header', {
      staticClass: "p-1",
      attrs: {
        "header-tag": "header",
        "role": "tab"
      },
      on: {
        "click": function($event) {
          _vm.ActiveAccordion(item.activeStatus, index)
        }
      }
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "cols": "4"
      }
    }, [_c('b-button', {
      staticClass: "text-left",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": item.is_followup_done == 0 ? 'warning' : 'info'
      }
    }, [_vm._v(_vm._s(item.meeting_code) + "\n              ")])], 1), _vm._v(" "), _c('b-col', {
      staticClass: "text-center",
      attrs: {
        "cols": "4"
      }
    }, [_c('b-button', {
      staticClass: "text-left",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": item.is_followup_done == 0 ? 'warning' : 'info'
      }
    }, [_c('b', [_vm._v("MOM User : ")]), _vm._v(_vm._s(item.mom_user_txt))])], 1), _vm._v(" "), _c('b-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "4"
      }
    }, [_c('b-button', {
      staticClass: "text-right",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": item.is_followup_done == 0 ? 'warning' : 'info'
      }
    }, [_vm._v(_vm._s(item.mom_datetime))])], 1)], 1)], 1), _vm._v(" "), (item.activeStatus) ? _c('b-card-body', [_c('b-card-text', [_c('b', [_vm._v("MOM Date : ")]), _vm._v(_vm._s(item.mom_datetime) + "\n                       "), _c('span', {
      staticClass: "text-right"
    }, [_c('b-button', {
      staticClass: "text-left",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": item.is_followup_done == 0 ? 'danger' : 'success'
      },
      on: {
        "click": function($event) {
          item.is_followup_done == 0 ?
            _vm.FollowupDone(
              item.meeting_code,
              item.fk_client_id,
              item.mom_id,
              item.is_followup_done == 0 ? 1 : 0
            ) :
            ''
        }
      }
    }, [_vm._v(_vm._s(item.is_followup_done == 0 ? "Followup Pending" : "Followup Done"))])], 1)]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Pridel User : ")]), _vm._v(_vm._s(item.mom_pridel_user))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("MOM User : ")]), _vm._v(_vm._s(item.mom_user))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Other User : ")]), _vm._v(_vm._s(item.other_mom_user_name))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("MOM Venue : ")]), _vm._v(_vm._s(item.mom_venue))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Minutes Of Meeting : ")]), _vm._l((item.mom_minutes_of_meeting.split('\n')), function(line, lineNumber) {
      return _c('span', {
        key: lineNumber
      }, [_c('p', {
        domProps: {
          "innerHTML": _vm._s(line)
        }
      }, [_vm._v(_vm._s(line))]), _vm._v(" "), _c('br')])
    })], 2), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Further Action : ")]), _vm._v(_vm._s(item.mom_further_action))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Followup Date : ")]), _vm._v(_vm._s(item.mom_followupdate))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Followup Time : ")]), _vm._v(_vm._s(item.mom_followup_time))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Assign To : ")]), _vm._v(_vm._s(item.assigned_user_txt))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Remark : ")]), _vm._l((item.mom_remark.split('\n')), function(lRemark, rindex) {
      return _c('span', {
        key: rindex
      }, [_vm._v("\n              " + _vm._s(lRemark)), _c('br')])
    })], 2)], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideClientMOMModal
    }
  }, [_vm._v("Close\n    ")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5590e2d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/clientJob/viewClientMOM.vue
// module id = 2644
// module chunks = 0